import React, { useEffect } from 'react';

const Chatbot = () => {
  useEffect(() => {
    const BASE_URL = "https://chatwoot-chatwoot.ittoqv.easypanel.host";

    const script = document.createElement('script');
    script.src = `${BASE_URL}/packs/js/sdk.js`;
    script.async = true;

    document.body.appendChild(script);

    script.onload = () => {
      if (window.chatwootSDK) {
        window.chatwootSDK.run({
          websiteToken: 'tp1Jaj8UJYDN3a4V4MNSouwb',
          baseUrl: BASE_URL,
        });
      }
    };

    return () => {
      document.body.removeChild(script);
      if (window.chatwootSDK) {
        window.chatwootSDK.reset && window.chatwootSDK.reset();
      }
    };
  }, []);

  return null;
};

export default Chatbot;